import { rem, spacing } from '@koaly/mixins';
import React from 'react';
import { down, up } from 'styled-breakpoints';
import styled from 'styled-components';

const StyledInputButtonGroup = styled.div `
  display: inline-flex;
  width: 100%;
  ${({ width }) => width && `max-width: ${typeof width !== 'string' ? rem(width) : width}`};
  flex-direction: row;

  > label {
    flex: 1;
  }

  ${down('xs')} {
    ${({ elevation, theme }) => `filter: drop-shadow(${theme.elevations[elevation]});`};
    flex-direction: column;

    input:first-child {
      margin-bottom: ${spacing(6)};
    }
  }
}

${up('s')} {
  border-radius: ${rem(56)};
  ${({ elevation, theme }) => `box-shadow: ${theme.elevations[elevation]};`};

  > button {
    margin-left: -50px;
    position: relative;
    z-index: 9;
  }
}
`;
const InputButtonGroup = ({ elevation, children, width }) => {
    return (React.createElement(StyledInputButtonGroup, { elevation: elevation, width: width }, children));
};
InputButtonGroup.defaultProps = {
    elevation: 2,
};

export { InputButtonGroup };
//# sourceMappingURL=InputButtonGroup.js.map
